import * as yup from 'yup';

export const deliveryOptionSchema = ({ cart_tag_id }) => {
  return {
    [cart_tag_id]: yup.object({
      delivery_option_id: yup.string().nullable().required({
        fieldKey: 'orders.fields.delivery_method',
        errorMessage: 'form.validation.required',
      }),
    }),
  };
};

export const zeekSchema = yup.object({
  selectedProvince: yup.string().required({
    fieldKey: 'delivery_address.region.hk',
    errorMessage: 'form.validation.required',
  }),
  selectedCity: yup.string().required({
    fieldKey: 'delivery_address.district.hk',
    errorMessage: 'form.validation.required',
  }),
  selectedStore: yup.object().nullable().required({
    fieldKey: 'zeek.station.address',
    errorMessage: 'form.validation.required',
  }),
});

export const sfExpressSchema = yup.object({
  district_translations: yup.object().nullable().required({
    fieldKey: 'delivery.sfexpress.district',
    errorMessage: 'form.validation.required',
  }),
  location_code: yup.string().required({
    fieldKey: 'delivery.sfexpress.store',
    errorMessage: 'form.validation.required',
  }),
});

export const sfPlusSchema = yup.object({
  district_translations: yup.object().nullable().required({
    fieldKey: 'delivery.sfexpress.locker_location',
    errorMessage: 'form.validation.required',
  }),
  location_code: yup.string().required({
    fieldKey: 'delivery.sfexpress.ef_locker',
    errorMessage: 'form.validation.required',
  }),
});

export const marketPickUpSchema = yup.object({
  location_code: yup.string().required({
    fieldKey: 'order.delivery_data.location_code',
    errorMessage: 'form.validation.required',
  }),
});
